// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ZFCJy"};